import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import TemplatesPage from "../pages/templates/page";
import SafetyPage from "../pages/safety/page";
import BeginnerPage from "../pages/beginner/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-templates-guide",
    element: <TemplatesPage />,
  },
  {
    path: "/superbuy-spreadsheet-safety-guide",
    element: <SafetyPage />,
  },
  {
    path: "/superbuy-spreadsheet-beginner-guide",
    element: <BeginnerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;